// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OZabL","name":"styles_name__3Aaf6","phone":"styles_phone__vyzDS"};